import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import TableLayout from "../../../../components/TableLayout";
import {
  getInfulencerList,
  updateInfluencerRequest,
  editUserStatus,
} from "../../../../store/affiliate/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
import FadeLoader from "react-spinners/FadeLoader";
import CommissionModal from "../../../../components/Modals/CommisionModal";

const InfluencerList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pageSize] = useState(10);
  const { influencer, loading, totalCount } = useSelector(
    (state) => state.AffiliateContent,
  );

  const [selectedStatus, setSelectedStatus] = useState("");
  const [filter, setFilter] = useState({
    status: "",
    page: 1,
    limit: pageSize,
    search: "",
  });

  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [pendingApprovalItem, setPendingApprovalItem] = useState(null);
  const [modalMode, setModalMode] = useState("approve"); // "approve" | "edit" | "reactivate"

  const fetchData = () => {
    try {
      const callback = (err, res) => {
        if (err) toast.error(err);
      };
      dispatch(getInfulencerList({ data: filter, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  useEffect(() => {
    fetchData();
  }, [filter]);

  useEffect(() => {
    if (selectedStatus !== filter.status) {
      setFilter((prev) => ({ ...prev, status: selectedStatus }));
    }
  }, [selectedStatus]);

  const handleApproveClick = (item) => {
    setModalMode("approve");
    setPendingApprovalItem(item);
    setShowCommissionModal(true);
  };

  const handleEditCommissionClick = (item) => {
    setModalMode("edit");
    setPendingApprovalItem(item);
    setShowCommissionModal(true);
  };

  const handleReactivateClick = (item) => {
    setModalMode("reactivate");
    setPendingApprovalItem(item);
    setShowCommissionModal(true);
  };

  const handleConfirmApproval = (commissionPercent) => {
    if (!pendingApprovalItem) return;
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success(res.message);
        }
      };

      if (modalMode === "approve") {
        dispatch(
          updateInfluencerRequest({
            id: pendingApprovalItem?._id,
            data: {
              action: "approved",
              adminNotes: "commission",
              commissionPercent,
            },
            callback,
          }),
        );
      } else if (modalMode === "edit" || modalMode === "reactivate") {
        dispatch(
          editUserStatus({
            id: pendingApprovalItem?.userId,
            data: {
              commissionPercent,
              status: "active",
            },
            callback,
          }),
        );
      }
    } catch (error) {
      console.error(error, "<=== Error occurred");
    } finally {
      setShowCommissionModal(false);
      setPendingApprovalItem(null);
    }
  };

  const handleRejectClick = (item) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success(res.message);
        }
      };
      dispatch(
        updateInfluencerRequest({
          id: item?._id,
          data: {
            action: "rejected",
            adminNotes: "commission",
            commissionPercent: 0,
          },
          callback,
        }),
      );
    } catch (error) {
      console.error(error, "<=== Error occurred");
    }
  };

  const handleSuspendClick = (item) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success(res.message);
        }
      };
      dispatch(
        editUserStatus({
          id: item?.userId,
          data: {
            commissionPercent: item?.commissionPercent ?? 0,
            status: "suspended",
          },
          callback,
        }),
      );
    } catch (error) {
      console.error(error, "<=== Error occurred");
    }
  };

  const handlePageChange = (page) => {
    setFilter((prev) => ({ ...prev, page: page.selected + 1 }));
  };

  const handleViewUser = (id) => {
    navigate(`/influencer/list/${id}`);
  };

  const ApproveIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M13.485 1.929a.75.75 0 0 1 1.06 1.06l-8 8a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06L6 9.44l7.485-7.51z" />
    </svg>
  );

  const RejectIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );

  const EditIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
    </svg>
  );

  const column = [
    {
      head: "Sr No",
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span className="text-capitalize cursor-pointer">
          {(filter.page - 1) * pageSize + (ind + 1)}
        </span>
      ),
    },
    {
      head: "Name",
      accessor: "name",
      isComponent: true,
      component: (item) => (
        <div className="content">
          <p className="m-0 text-muted text-capitalize">{item?.user?.name}</p>
        </div>
      ),
    },
    {
      head: "Email Address",
      accessor: "email",
      isComponent: true,
      component: (item) => <span className="text">{item?.user?.email}</span>,
    },
    {
      head: "Created At",
      accessor: "createdAt",
      isComponent: true,
      component: (item) => (
        <span className="text">
          {moment(item?.createdAt).format("YYYY-MM-DD")}
        </span>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      isComponent: true,
      component: (item) => (
        <p
          className={`${
            item.status === "pending"
              ? "yellowStatus"
              : item.status === "rejected" || item.status === "suspended"
                ? "redStatus"
                : item.status === "approved" || item.status === "active"
                  ? "greenStatus"
                  : ""
          } status text-capitalize m-0 d-flex justify-content-center align-item-center rounded-pill px-3 py-1`}
        >
          {item.status}
        </p>
      ),
    },
    // ── NEW: Commission column — only meaningful for approved/active ──
    {
      head: "Commission (%)",
      accessor: "commissionPercent",
      isComponent: true,
      component: (item) => {
        const isApproved =
          item.status === "approved" || item.status === "active";
        if (!isApproved) return <span className="text text-muted">—</span>;
        return (
          <span className="text fw-sbold">
            {item?.user?.commissionPercent != null
              ? `${item?.user?.commissionPercent}%`
              : "—"}
          </span>
        );
      },
    },
    {
      head: "Actions",
      accessor: "",
      isComponent: true,
      component: (item) => {
        const status = item.status;

        return (
          <div className="ActnBtn d-flex align-items-center gap-10">
            <div className="d-flex gap-2">
              {status === "pending" && (
                <>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => handleApproveClick(item)}
                    title="Approve"
                  >
                    <ApproveIcon />
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleRejectClick(item)}
                    title="Reject"
                  >
                    <RejectIcon />
                  </Button>
                </>
              )}

              {(status === "approved" || status === "active") && (
                <>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleSuspendClick(item)}
                    title="Suspend"
                  >
                    <RejectIcon />
                  </Button>
                  <Button
                    variant="outline-warning"
                    size="sm"
                    onClick={() => handleEditCommissionClick(item)}
                    title="Edit Commission"
                  >
                    <EditIcon />
                  </Button>
                </>
              )}

              {status === "rejected" && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleReactivateClick(item)}
                  title="Re-approve"
                >
                  <ApproveIcon />
                </Button>
              )}
            </div>

            {/* <Button
              onClick={() => handleViewUser(item._id)}
              className="p-0"
              variant="transparent"
              type="button"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5Z"
                  fill="#6F6F6F"
                />
              </svg>
            </Button> */}
          </div>
        );
      },
    },
  ];

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}

      <section className="ManageTeacher position-relative">
        <Container>
          <div className="pb-2 cardCstm">
            <Row className="px-3 py-2 bg-white align-items-center">
              <Col lg="12" className="my-2 px-0">
                <div className="px-3 d-flex align-items-center justify-content-between gap-10">
                  <h5 className="mb-0 py-3 fw-sbold text-capitalize px-3">
                    Influencer List
                  </h5>
                </div>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Control
                  type="text"
                  name="search"
                  value={filter.search || ""}
                  placeholder="Search using name or email"
                  onChange={(e) =>
                    setFilter((prev) => ({ ...prev, search: e.target.value }))
                  }
                />
              </Col>
              <Col md={3} className="mb-3">
                <Form.Select
                  className="p-2"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </Form.Select>
              </Col>
            </Row>
          </div>

          <Row>
            {!loading && (
              <Col lg="12" className="mx-0">
                <div className="cardCstm p-3 rounded bg-white">
                  {influencer?.length > 0 ? (
                    <TableLayout
                      data={influencer}
                      column={column}
                      totalCount={totalCount}
                      limit={filter.limit}
                      loading={loading}
                      handlePageChange={handlePageChange}
                      pageNo={filter.page}
                      status={"status"}
                    />
                  ) : (
                    <div className="d-flex justify-content-center">
                      <p>No Data Found</p>
                    </div>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>

      <CommissionModal
        show={showCommissionModal}
        onHide={() => {
          setShowCommissionModal(false);
          setPendingApprovalItem(null);
        }}
        onConfirm={handleConfirmApproval}
        influencerName={pendingApprovalItem?.user?.name}
        modalMode={modalMode}
        commision={pendingApprovalItem?.user?.commissionPercent}
      />
    </>
  );
};

export default InfluencerList;
